import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApiLoadingStatus } from "enum/api-loading-status.enum";

interface BulkEditState {
  isSubmitting: boolean;
  submitStatus: ApiLoadingStatus;
  errors: { [shipmentId: string]: string[] };
  progress: {
    total: number;
    completed: number;
    failed: number;
  };
}

const initialState: BulkEditState = {
  isSubmitting: false,
  submitStatus: ApiLoadingStatus.IDLE,
  errors: {},
  progress: { total: 0, completed: 0, failed: 0 },
};

export const bulkEditSlice = createSlice({
  name: 'bulkEdit',
  initialState,
  reducers: {
    setBulkEditSubmitting: (state, action: PayloadAction<boolean>) => {
      state.isSubmitting = action.payload;
    },
    setBulkEditProgress: (state, action: PayloadAction<{ total: number; completed: number; failed: number }>) => {
      state.progress = action.payload;
    },
    addBulkEditError: (state, action: PayloadAction<{ shipmentId: string; errors: string[] }>) => {
      const { shipmentId, errors } = action.payload;
      state.errors[shipmentId] = errors;
    },
    clearBulkEditState: (state) => {
      state.errors = {};
      state.progress = { total: 0, completed: 0, failed: 0 };
    },
    resetBulkEditState: () => initialState,
  }
});

export const {
  setBulkEditSubmitting,
  setBulkEditProgress,
  addBulkEditError,
  clearBulkEditState,
  resetBulkEditState
} = bulkEditSlice.actions;

export default bulkEditSlice.reducer;